import { toSentenceCase } from '@noths/polaris-client-utils';

import { FacetUID } from 'src/components/organisms/Filter/constants/uids';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { SortOption } from 'src/redux/productsQuery/types/SortOption';

export const getFacetsWithSortAsAFacet = (facets: Facet[], sortOptions: SortOption[]) => {
  const sortFacet: Facet = {
    active: false,
    options: sortOptions.map(({ active, id, title }) => ({
      uid: id,
      value: id,
      title: toSentenceCase(title),
      active,
      activeCount: null,
      minValue: null,
      maxValue: null,
    })),
    title: 'Sort',
    type: 'radio',
    uid: FacetUID.Sort,
  };

  return [sortFacet, ...facets];
};
